const hideModalSubmitWrapper = "hideModalSubmitWrapper";

export const showFormProcessing = ($submitButton) => {
  $submitButton.prop("disabled", true);
  $submitButton.addClass("inProcess");
  $submitButton.find(".submit-label").css("opacity", "0.5");
};

export const endFormProcessing = ($submitButton) => {
  $submitButton.prop("disabled", false);
  $submitButton.removeClass("inProcess");
  $submitButton.find(".submit-label").css("opacity", "1");
};

export const showSubmissionText = ($submitButton) => {
  const $confirmIcon = $submitButton.find(".confirm-icon");
  $submitButton.find(".submit-label").text("Submitted");
  $confirmIcon.show();
  return hideModalSubmitWrapper;
};

export const resetSubmissionText = ($submitButton) => {
  const $confirmIcon = $submitButton.find(".confirm-icon");
  const submitLabel = $submitButton.find(".submit-label").data("submit-label");
  $submitButton.find(".submit-label").text(submitLabel);
  $confirmIcon.hide();
};

export const handleUncontrolledSubmitButton = (cb) => {
  const $uncontrolledSubmitButtonWrapper = $(".sticky-submit");
  const $uncontrolledSubmitButton = $uncontrolledSubmitButtonWrapper.find(
    "button"
  );

  const shouldHideModal =
    cb($uncontrolledSubmitButton) === hideModalSubmitWrapper;

  if (shouldHideModal) {
    $uncontrolledSubmitButtonWrapper.hide();
    $uncontrolledSubmitButton.find(".submit-label").text("Submit");
    $uncontrolledSubmitButton.find(".confirm-icon").hide();
  }
};
